import { Component } from '@angular/core';

@Component({
  selector: 'app-error-404',
  templateUrl: './error404.component.html',
  styleUrls: []
})
export class Error404Component {

}
